/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Trite_Warm_Clownfish_BelongInputs */

const fr_trite_warm_clownfish_belong = /** @type {(inputs: Trite_Warm_Clownfish_BelongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retrouve et donne tous tes records sur chaque exercice sur ton profile. Cela te permet de suivre ta progression et de te motiver à battre tes records.<br /> En plus dans chaque séance, si un exercice demande une charge spécifique, le calcul sera fait en fonction de ton record personnel.`)
};

/**

* @param {Trite_Warm_Clownfish_BelongInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const trite_warm_clownfish_belong = /** @type {((inputs?: Trite_Warm_Clownfish_BelongInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Trite_Warm_Clownfish_BelongInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_trite_warm_clownfish_belong(inputs)
});